<i18n>
{
  "fr": {
    "fr": "Français",
    "de": "Allemand"
  },
  "de": {
    "fr": "Französisch",
    "de": "Deutsch"
  }
}
</i18n>

<template>

  <div id="header">
    <md-content class="md-elevation-3 header-container">
    <div class="vs-logo">
      <router-link :to="isConnected ? '/dashboard' : '#'"><img src="../assets/images/logo/vs.svg" /></router-link>
    </div>
    <div class="vs-logo-text">
      <!-- David Good Enough... ;) -->
      <router-link :to="isConnected ? '/dashboard' : '#'"><img src="../assets/images/logo/vs_text.png" /></router-link>
    </div>
      <div class="header-title">
        <h2>{{ title }}</h2>
      </div>
      <div class="lang-menu">
        <md-menu md-direction="bottom-end">
          <md-button md-menu-trigger>{{$t($root.$i18n.locale)}}</md-button>

          <md-menu-content>
            <md-menu-item @click="$root.$i18n.locale = 'fr'">{{ $t('fr') }}</md-menu-item>
            <md-menu-item @click="$root.$i18n.locale = 'de'">{{ $t('de') }}</md-menu-item>
          </md-menu-content>
        </md-menu>
      </div>
    </md-content>
  </div>

</template>

<script>

import AccessToken from '@/helpers/access-token'

export default {
  name: 'Header',
  props: {
    title: {
      type: String
    }
  },
  event: 'change',
  data () {
    return {
      isConnected: AccessToken.get() !== null
    }
  }
}
</script>

<style lang="scss">
  .header-container {
    max-width: 1570px;
    margin: 0 auto;
    margin-top: 10px;
    padding: 5px;
    margin-bottom: 20px;
    background: url('../assets/images/general/bgHeader.png');
    background-repeat: no-repeat;
    background-position: right;
    background-position-x: 82%;
    display: flex;
    align-items: center;
  }

  .lang-menu {
    padding-right: 10px;

    @media(max-width: 465px){
      position: fixed;
      right: 0;
      top: 0;
    }

  }

  .header-title {
    padding-left: 20px;
    padding-right: 10px;
    flex: 1 1 auto;
  }

  .vs-logo {
    @media(max-width: 960px){
      margin-top: -20px;
      margin-left: 45px;

      img {
        min-width: 45px;
      }
    }
    @media(min-width: 960px){
      display: none;
    }
  }

  .vs-logo-text {
    @media(min-width: 960px){
      margin-top: -20px;
      padding-bottom: 10px;
      padding-left: 10px;
      img {
        width: 100px;
      }
    }
    @media(max-width: 960px){
      display: none;
    }
  }
</style>
